document.querySelectorAll('.tabs').forEach(parent => {
  let tabNavs = parent.querySelectorAll('.tab')

  for (let i = 0; i < tabNavs.length; i++) {
    tabNavs[i].addEventListener('click', function (event) {
      event.preventDefault()

      let activeTabPanes = parent.querySelectorAll('.active[data-tab-content]')
      activeTabPanes.forEach(x => x.classList.remove('active'))

      let activeTabAttr = event.target.getAttribute('data-tab')
      let contentAttr = parent.querySelectorAll(
        `[data-tab-content="${activeTabAttr}"]`
      )
      contentAttr.forEach(x => x.classList.add('active'))

      let tabArr = parent.querySelectorAll(`[data-tab]`)
      tabArr.forEach(x => x.classList.remove('active'))
      event.target.classList.add('active')
    })
  }
})
